const INITIAL_SHOW_DELAY = 1200;

export default class Anchor {
    constructor() {
        this.$anchor = document.querySelector(".js-howto4th-anchor");
        this.$footer = document.querySelector(".js-gfooter");

        if (!this.$anchor) return;

        this.$links = [...this.$anchor.querySelectorAll('a[href^="#"]')];
        this.targets = this.$links
            .map(($link) => ({ $link, $section: document.querySelector($link.hash) }))
            .filter(({ $section }) => $section);
        this.$links.forEach(($link) => $link.addEventListener("click", (event) => this.scroll(event, $link)));

        this.isInitial = true;
        this.toggle = this.toggle.bind(this);
        window.addEventListener("scroll", this.toggle, { passive: true });
        window.addEventListener("resize", this.toggle);
        this.toggle();

        const showAnchor = () =>
            window.setTimeout(() => {
                this.isInitial = false;
                this.toggle();
            }, INITIAL_SHOW_DELAY);

        if (document.readyState === "complete") {
            showAnchor();
        } else {
            window.addEventListener("load", showAnchor, { once: true });
        }
    }

    toggle() {
        this.updateCurrent();

        if (this.isInitial) return;

        const anchorBottom = parseFloat(window.getComputedStyle(this.$anchor).bottom) || 0;
        const anchorTop = window.innerHeight - anchorBottom - this.$anchor.offsetHeight;
        const footerTop = this.$footer ? this.$footer.getBoundingClientRect().top : Infinity;
        const isFooterOverlapping = footerTop <= anchorTop;

        this.$anchor.classList.toggle("-show", !isFooterOverlapping);
    }

    updateCurrent() {
        const marker = window.innerHeight * 0.4;
        const $newteam = document.querySelector("#newteam");
        const current = this.targets.find(({ $link, $section }) => {
            const rect = $section.getBoundingClientRect();
            const bottom = $link.hash === "#story" && $newteam ? $newteam.getBoundingClientRect().top : rect.bottom;

            return rect.top <= marker && bottom > marker;
        });

        this.targets.forEach(({ $link }) => {
            const isCurrent = $link === current?.$link;

            $link.classList.toggle("-current", isCurrent);

            if (isCurrent) {
                $link.setAttribute("aria-current", "location");
            } else {
                $link.removeAttribute("aria-current");
            }
        });
    }

    scroll(event, $link) {
        const $target = document.querySelector($link.hash);

        if (!$target) return;

        event.preventDefault();

        const offset = this.$anchor.getBoundingClientRect().height;
        const top = Math.max(0, window.scrollY + $target.getBoundingClientRect().top - offset);
        const behavior = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";

        window.scrollTo({ behavior, top });
    }
}
